<script>
import workflowlist from "../components/automation-archive/workflow-list.vue";
import PageHeading from "../components/global/PageHeading.vue";
import { PLAN_SKU_TYPES } from "../utils/constants";

const { FREE_PLAN, SUSPENDED_PLAN, TRIAL_PLAN } = PLAN_SKU_TYPES;

export default {
  components: {
    workflowlist,
    PageHeading,
  },
  data() {
    return {
      steps: [
        {
          target: "#workflows_page_heading",
          content:
            "Predefine your approval process with workflows. Append a workflow to any proof at any time.",
          params: { placement: "bottom" },
        },
      ],
      tourCallbacks: {
        onStop: () => window.$A.SaveCompletionOfProductTours("workflows-page"),
      },
    };
  },
  computed: {
    isFreeUser() {
      const sub = _.get(this.$A, "Auth.account.subscriptionState", {});
      return sub.sku === FREE_PLAN || sub.sku === SUSPENDED_PLAN || sub.sku === TRIAL_PLAN;
    },
  },
  mounted() {
    this.$A.ClearViewData();
    window.$A.ProductTourProcess("workflows-page", this);
  },
};
</script>

<template>
  <div class="nav-margin">
    <navigation></navigation>
    <PageHeading
      anchor-id="workflows_page_heading"
      title="Workflows"
      description="Predefined approval sequences you can append to any proof."
    />
    <workflowlist :isPaidAccount="!isFreeUser" />
    <v-tour name="workflows-page" :steps="steps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>
